import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateParser } from '@ngx-translate/core';
import { IWFOverviewItem, WFStatus } from '@vierkant-software/types__api';
import { defaultModules } from 'src/app/util/defaultModules';
import { AppService } from 'src/services/app.service';
import { GcTranslateParser } from 'src/services/GcTranslateParser.service';
import { WorkFlowService } from '../../../services/workflow.service';
import { DateTime } from 'luxon';
import { Color } from 'src/app/components/v-icon/types';

@Component({
    selector:        'overview-item',
    templateUrl:     './overview-item.component.haml',
    styleUrls:       ['./overview-item.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [
        ...defaultModules
    ],
    providers: [{ provide: TranslateParser, useClass: GcTranslateParser }]
})
export class OverviewItemComponent {

  ticket = input<IWFOverviewItem>(undefined);
  openTicket = output<IWFOverviewItem>();
  template = computed(() => 'WORKFLOW.' + this.wf.templateNames[this.ticket().templateId]);
  myUserId = this.app.myUserId;
  status = computed(() => this.statusConfig[this.ticket().status]);
  isClosed = computed(() => this.ticket().finalized !== undefined);

  private readonly statusConfig: Record<WFStatus, { icon: string, color: Color, text: string }> = {
    [WFStatus.accepted]:  { icon: 'circle-check', color: 'success', text: 'CLOSED' },
    [WFStatus.rejected]:  { icon: 'circle-xmark', color: 'danger', text: 'CLOSED' },
    [WFStatus.failed]:    { icon: 'circle-exclamation', color: 'warn', text: 'FAILED' },
    [WFStatus.discarded]: { icon: 'circle-minus', color: 'warn', text: 'DISCARDED' },
  };

  constructor(private app: AppService, private wf: WorkFlowService) {}

  cardClicked() {
    this.openTicket.emit(this.ticket());
  }

  get delayed() {
    return this.ticket().personal?.delayTill > DateTime.now();
  }
}
